import React,{ Component } from "react";
import { connect } from "react-redux";
import { getKasm } from "../../actions/actionKasm";
import { destoryKasms } from "../../actions/actionDashboard";
import { Link } from "react-router-dom";
import ReactTable from "react-table";
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner, UncontrolledTooltip, Card, CardBody, CardHeader } from "reactstrap";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import { NotificationManager } from "react-notifications";
import "react-table/react-table.css";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../components/Breadcrumb/BreadCrumbCompo";
import moment from "moment";
import { fuzzySearch } from "../../utils/helpers";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Kasms",path:"/kasm",isActive: true}
];

class Kasms extends Component{
    constructor(props) {
        super(props);        
        this.state = {
            modal: false,
            pages: 1,
            kasmId: null,
            deleteClicked: false
        };
        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.deleteKasmAction = this.deleteKasmAction.bind(this);
        this.handleDeleteSuccess = this.handleDeleteSuccess.bind(this);
        this.handleDeleteError = this.handleDeleteError.bind(this);
        this.cancelDelete = this.cancelDelete.bind(this);
    }

    componentDidMount(){
        this.props.getKasm();
    }

    deleteConfirm(kasmId){
        this.setState({modal: !this.state.modal,
            kasmId: kasmId});
    }

    cancelDelete(){
        this.setState({modal: !this.state.modal}); 
    }

    deleteKasmAction(){
        this.setState({deleteClicked: true});
        this.props.destoryKasms(this.state.kasmId).
            then(() => this.handleDeleteSuccess()).
            catch(() => this.handleDeleteError());
    }   

    handleDeleteSuccess(){
        const {destoryKasmsErrorMessage} = this.props;
        if(destoryKasmsErrorMessage) {
            NotificationManager.error(destoryKasmsErrorMessage,"Failed to Delete Kasm", 3000);
        }else{
            NotificationManager.success("Kasm Deleted Successfully","Delete Kasm", 3000);
            this.setState({modal: false, deleteClicked: false});
            this.props.getKasm();
        }
    }

    handleDeleteError(){
        const {destoryKasmsError} = this.props;
        if(destoryKasmsError){
            NotificationManager.error(destoryKasmsError,"Failed to Delete Kasm", 3000);
            this.props.history.push("/kasm");
        }else{
            NotificationManager.error("Failed to Delete Kasm","Delete Kasm", 3000);
            this.props.history.push("/kasm");
        }
    }

    render(){
        if (this.props.getKasmLoading){
            return (<div> <LoadingSpinner /></div>);
        }
        const { kasms, current_time } = this.props;
        const { loading } = this.state;
        const columns = [{ Header: "Kasm Id",
            accessor: "kasm_id",
            filterMethod: fuzzySearch
        },
        {
            Header: "Image",
            accessor: "image.friendly_name",
            filterMethod: fuzzySearch,
            Cell: (data) => (<div>
                <Link to={"/viewimage/" + data.original.image_id}>
                    {data.original.image.friendly_name}
                </Link>
            </div>)
        },
        {
            Header: "User",
            accessor: "user.username",
            filterMethod: fuzzySearch,
            Cell: (data) => (<div>
                <Link to={"/viewuser/" + data.original.user_id}>
                    {data.original.user.username}
                </Link>
            </div>)

        },
        {
            Header: "Status",
            accessor: "operational_status",
            filterMethod: fuzzySearch
        },
        {
            Header: "Last Active",
            accessor: "keepalive_date",
            filterable: false,
            Cell: (data) => (<div>
                    {moment.utc(moment.utc(current_time).diff(moment.utc(data.original.keepalive_date), "hh:mm:ss")).format("mm") < 5 ?
                        <span className="text-success">Logged In</span> :
                        moment.utc(moment.utc(current_time).diff(moment.utc(data.original.keepalive_date), "hh:mm:ss")).format("HH:mm:ss")}
                </div>)
        },
        {
            Header: "Agent",
            accessor: "server.hostname",
            filterMethod: fuzzySearch,
            Cell: (data) => (<div>
                <Link to={"/viewagent/" + data.original.server_id}>
                    {data.original.server.hostname}
                </Link>
            </div>)
        },
        {
            Header: "Zone",
            accessor: "server.zone_name",
            filterMethod: fuzzySearch
        },
        {
            Header: "Container IP",
            accessor: "container_ip",
            filterMethod: fuzzySearch
        },
        {
            Header: "Uptime",
            accessor: "start_date",
            filterable: false,
            Cell: (data) => (<div>
                {moment.utc(data.original.current_time).diff(moment.utc(data.original.start_date), "days" ) ?
                 moment.utc(data.original.current_time).diff(moment.utc(data.original.start_date), "days" ) + "d:" : ""}
                {moment.utc(moment.utc(current_time).diff(moment.utc(data.original.start_date), "hh:mm:ss")).format("HH:mm:ss")}
                </div>)
        },
        {
            Header: "Actions",
            filterable: false,
            sortable: false,
            Cell: (data) => (<div className="action-btn">
                <Link className="btn btn-success"  to={{ pathname: `/viewkasm/${data.original.kasm_id}`}} >
                    <i className="fa fa-eye" id={"TooltipComponent"}></i> </Link>
                <button className="btn btn-danger"  id={"Tooltips"} href="#"  onClick={() => this.deleteConfirm(data.original.kasm_id)}>
                    <i className="fa fa-trash-o"></i> </button>    
                <UncontrolledTooltip placement="right" target={"TooltipComponent"}> View </UncontrolledTooltip>
                <UncontrolledTooltip placement="right" target={"Tooltips"}> Delete </UncontrolledTooltip>
            </div>
            ),
        }];

        return (
            <div> 
                <BreadCrumbCompo routes={routes}/>    
                <Row>
                    <Col sm={{ size: 10, order: 3, offset: 1 }}>
                        <Card >
                            <CardHeader>
                                <i className="fa fa-align-justify"></i> <strong>Kasms</strong>
                            </CardHeader>
                            <CardBody>
                                <ReactTable
                                    columns={columns}
                                    data={kasms}
                                    defaultSorted={[{id: "keepalive_date",  desc : true}]}
                                    loading={loading}
                                    filterable
                                    defaultPageSize={10}
                                    className="-striped -highlight site_table black-link"
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Modal isOpen={this.state.modal} toggle={this.cancelDelete} className={this.props.className}>
                    <ModalHeader toggle={this.cancelDelete}>Delete Kasm <i className="fa fa-bomb" aria-hidden="true"></i>
                    </ModalHeader>
                    <ModalBody>
                       Confirm Delete Kasm?
                    </ModalBody>
                    <ModalFooter>
                        { this.state.deleteClicked ?
                            <Spinner size="sm" color={"danger"} />
                            :
                            <Button onClick={this.deleteKasmAction} size="sm" color="danger"> <i className="fa fa-trash"></i> Delete</Button>
                        }
                        <Button onClick={this.cancelDelete} size="sm" color="basic"><i className="fa fa-ban"></i> Close</Button>
                    </ModalFooter>
                </Modal>

            </div>
        );
    }
}

Kasms.propTypes = {
    getKasm: Proptypes.func.isRequired,
    kasms: Proptypes.array,
    current_time: Proptypes.string,
    destoryKasms: Proptypes.func,
    destoryKasmsErrorMessage: Proptypes.string,
    destoryKasmsError: Proptypes.string,
    getkasmLoading: Proptypes.bool,
    className: Proptypes.func,
    history: Proptypes.object,
    getKasmLoading: Proptypes.bool,
};


export default connect(state => 
    ({
        kasms: state.kasms.kasms || [],
        current_time: state.kasms.current_time || null,
        getKasmLoading: state.kasms.getKasmLoading || false,
        destoryKasmsErrorMessage: state.images.destoryKasmsErrorMessage || null,
        destorykasmsLoading: state.images.destorykasmsLoading || false,
        destoryKasmsError: state.images.destoryKasmsError || null
    }),
dispatch => 
    ({  
        getKasm: () => dispatch(getKasm()),
        destoryKasms: (data) => dispatch(destoryKasms(data))
    }))(Kasms);



// WEBPACK FOOTER //
// ./src/views/Kasms/Kasm.js